import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { richTextChildren } from '../../../common/richTextChildren';
import { TypedMemo } from '../../../common/types';
import { useWorkspaces } from '../../../workspaces/useWorkspaces';
import { mailboxMessages as messages } from './mailboxMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Mailboxes card; each part uses its own slice of it */
import styles from './Mailboxes.module.scss';

const bold = (chunks: React.ReactNode[]) => <b>{chunks}</b>;

/** The rights line at the bottom of the card, with a lock (design outreach-v2 q1, q4). */
const MailboxRightsComponent: React.FC<{ isOwner: boolean }> = ({ isOwner }) => {
  const intl = useIntl();
  const ownerEmail = useWorkspaces().active?.ownerEmail ?? null;
  const text = () => {
    if (isOwner) {
      return intl.formatMessage(messages.ownerRights, { b: bold });
    }
    return ownerEmail === null
      ? intl.formatMessage(messages.memberNoteNoOwner)
      : intl.formatMessage(messages.memberNote, { owner: <b key="owner">{ownerEmail}</b> });
  };
  return (
    <div className={styles.rights} data-testid={isOwner ? 'mailbox-rights' : 'mailboxes-member-note'}>
      <FontAwesomeIcon icon={faLock} className={styles.rightsIcon} />
      {/* QA skpr2-3: the rich text as fixed children, so React gives no key warning. */}
      <span>{richTextChildren(text())}</span>
    </div>
  );
};

export const MailboxRights = TypedMemo(MailboxRightsComponent);
